<template lang="pug">
.fill-height.d-flex.flex-column
  div
    v-list-item.ma-0.pr-3
      v-list-item-content
        v-list-item-title
          v-card-title.pa-0: strong {{ item.user.full_name }}
        v-list-item-subtitle
          mentors-list(
            v-model="mentorId"
            :item="item"
            @selectMentored="$emit('selectMentored', $event)"
            @change="changeMentor"
          )
      v-list-item-action.align-self-start.mt-2
        tooltip-wrap(text="Открыть чат" v-if="item.is_active")
          v-badge(:value="item.chat.exists_unread_messages" dot overlap color="error")
            v-btn(
              icon
              color="secondary"
              @click="openChat"
            )
              v-icon() mdi-chat

  v-card-text.fill-height.my-0.py-0
    v-list-item.pl-2
      v-list-item-icon(
        v-if="item.is_active"
      )
        tooltip-wrap
          template(#reason)
            .d-flex.flex-column
              .pb-1.text-caption Курсы: 3 / 4
              .pb-1.text-caption Практики: 0 / 1
              .pb-1.text-caption Анкеты: 1 / 1
          v-progress-circular.mt-1(
            size="58" color="success" rotate="-90" value="65" width="10"
          )
            .text-caption: strong 4/6
      v-list-item-content
        v-list-item-subtitle.text-caption Категория:
        v-list-item-title.primary--text: strong Экономическая безопасность

    template(v-if="questionnaires.length && !item.is_active")
      h4.mt-6 Анкета:
      v-alert(
        v-if="!questionnaires[0].isComplete"
        prominent type="warning"
      ) Анкета не пройдена
      v-card(outlined max-height="300px" v-else).overflow-auto.scroll.pa-2
        questionare-detail(:item="questionnaires[0]")

    template(v-else)
      v-alert( type="error" text) Есть просроченные рекомендации
      .text-center
        v-date-picker(
          ref="picker"
          no-title
          :events="functionEvents"
          :first-day-of-week="1"
          @click:date="showMenu"
          width="395"
        )
        v-menu(
          v-model="menu.value"
          :position-x="menu.position.x"
          :position-y="menu.position.y"
          :close-on-content-click="false"
          absolute
          offset-y
          @click:outside="showMenu"
        )
          v-card.sdo-card.secondary(
            v-if="menu.data"
            dark
          )
            .d-flex
              v-card-title.text-body-2.pb-0 {{ menu.data.date | dp('d MMMM y')}}
              v-spacer
              v-btn.mt-2.mr-2(
                icon color="error" @click="menu.value = false"
              ): v-icon mdi-close
            v-list.transparent.pt-0
              v-list-item
                v-list-item-content
                  div
                    v-chip(color="error" x-small)
                      v-icon(small left) mdi-alert
                      span Просрочена
                  v-list-item-title Тестовая рекомендация
                  v-list-item-subtitle.primary--text.text--lighten-4.text-caption.
                    от {{ menu.data.date | dp('d MMMM y')}}
              v-list-item
                v-list-item-content
                  div
                    v-chip(color="success" x-small)
                      v-icon(small left) mdi-check
                      span Выполнена
                  v-list-item-title Тестовая рекомендация
                  v-list-item-subtitle.primary--text.text--lighten-4.text-caption.
                    от {{ menu.data.date | dp('d MMMM y')}}

  v-card-actions.mt-auto.mt-2.sticky-bottom.white
    v-btn(
      v-if="!item.is_active"
      block color="primary"
      :disabled="!mentorId"
      @click="acceptRequest"
    ) Принять заявку
    v-btn.ml-auto(
      v-else
      color="primary" outlined
      :to="{ name: 'MentoredView', params: { id: item.id } }"
    ) Подробнее
</template>
<script>
import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';
import CInput from '@/components/Constructor/CInput.vue';
import PracticeCard from './recommendation/RecomendationListDetail.vue';
// import RecommendationDetail from './recommendation/RecommendationDetail.vue';
import QuestionareDetail from './questionare/QuestionareDetail.vue';
import MentorsList from './MentorsList.vue';
// import RecommendationCreate from './recommendation/RecommendationCreate.vue';
// import AutocompleateQuestionare from './questionare/AutocompleateQuestionare.vue';

export default {
  components: {
    RecordStatusWrap,
    CInput,
    PracticeCard,
    QuestionareDetail,
    MentorsList,
  },
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      menu: {
        value: false,
        position: {
          x: 0,
          y: 0,
        },
        data: null,
      },
      date: null,
      data: '',
      tab: 0,
      mentorId: this.item.mentor_id,
      mentor: null,
      loading: false,
    };
  },
  computed: {
    questionnaires() {
      const { questionnaire_forms: forms, questionnaires } = this.item;
      if (forms) {
        return questionnaires.reduce((acc, cur) => {
          const {
            form_answers: answers = [],
            is_complete: isComplete,
            id: questionnaireFormId,
          } = forms.find(({ questionnaire_id: id }) => cur.id === id) || { };
          acc.push({
            ...cur, answers, isComplete, questionnaireFormId,
          });
          return acc;
        }, []);
      }
      return questionnaires;
    },
  },
  created() {
    this.getMentorRecommendations();
  },
  methods: {
    changeMentor(mentor) {
      this.$set(this.item, 'mentor_id', mentor.id);
      this.$set(this.item, 'mentor', mentor);
    },
    getMentorRecommendations() {
      this.$api.mentoring.mentorRecommendations({
        'search[user_id]': this.item.user_id,
        'search[organization_id]': this.$user.organization.id,
        expand: 'owner,organization,course_recommendations,pages,user_prior_records',
      });
    },
    showMenu(value, event) {
      const { x, y } = event;
      this.menu = {
        value: false,
        position: { x, y },
        data: { date: value },
      };
      this.menu.position = { x, y };
      setTimeout(() => {
        this.menu.value = true;
      }, 10);
    },
    functionEvents(date) {
      const day = parseInt(date.split('-')[2], 10);
      if ([1, 5].includes(day)) return ['success'];
      if ([6, 10, 29].includes(day)) return ['error'];
      if ([22].includes(day)) return ['success', 'error'];
      return false;
    },

    openChat() {
      this.item.chat.open({ title: 'Чат c наставляемым:', subtitle: this.item.user.full_name });
    },
    async acceptRequest() {
      const { mentorId } = this;
      await this.$api.mentoring.acceptRequest(
        this.$user.organization.id, this.item.user_id, { mentor_id: mentorId },
      );
      this.$set(this.item, 'is_active', true);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-date-picker-table {
  height: auto !important
}
</style>
